import React from 'react';

const Process = () => {
  const steps = [
    {
      title: "Assess",
      description: "Review existing systems, workflows, and operational requirements."
    },
    {
      title: "Design",
      description: "Define practical technical solutions aligned with business needs."
    },
    {
      title: "Implement",
      description: "Configure systems, deploy automations, and validate functionality."
    },
    {
      title: "Support",
      description: "Provide documentation, training, and ongoing optimization."
    }
  ];

  return (
    <div className="bg-background py-16 md:py-24 px-6 md:px-10 border-t border-slate-200/60">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12">
          <p className="text-xs font-medium tracking-widest uppercase text-text-secondary mb-3">Our Approach</p>
          <h2 className="text-2xl md:text-3xl font-semibold text-text-primary">How We Work</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-soft-surface border border-slate-200/60 p-6 rounded-lg h-full">
                <div className="flex items-center mb-4">
                  <div className="w-8 h-8 bg-accent text-white rounded-full flex items-center justify-center text-sm font-semibold mr-3">
                    {index + 1}
                  </div>
                  <h3 className="text-lg font-semibold text-text-primary">
                    {step.title}
                  </h3>
                </div>
                <p className="text-base text-text-secondary leading-7">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-0.5 bg-slate-200/60 transform -translate-y-1/2 z-10">
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-4 border-l-slate-200/60 border-t-2 border-t-transparent border-b-2 border-b-transparent"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Process;
